module.exports = __webpack_public_path__ + "img/WorkPolicy.bdf26378.svg";